import React from 'react';
import ExperimentContext from '../experiment/provider';

const withExperiment = <T,>(WrappedComponent: React.FC<T>): React.FC<T> => {
  return (props) => {
    return (
      <ExperimentContext.Consumer>
        {context => (
          <WrappedComponent
            {...props}
            experiments={{ ...context }}
          />
        )}
      </ExperimentContext.Consumer>
    );
  };
};
export default withExperiment;
